
const memoryCache = new Map();

export function setCache(key, value) {
  const payload = { value, ts: Date.now() };
  memoryCache.set(key, payload);

  try {
    localStorage.setItem(key, JSON.stringify(payload));
  } catch (error) {
    console.warn('Cache write warning:', error);
  }
}

export function getCache(key, ttlMs = 5 * 60 * 1000) {
  const mem = memoryCache.get(key);
  if (mem && Date.now() - mem.ts < ttlMs) {
    return mem.value;
  }

  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;

    const parsed = JSON.parse(raw);

    if (!parsed?.ts || Date.now() - parsed.ts >= ttlMs) {
      localStorage.removeItem(key);
      return null;
    }

    memoryCache.set(key, parsed);
    return parsed.value;
  } catch (error) {
    console.warn('Cache read warning:', error);
    return null;
  }
}

export function clearCache(key) {
  memoryCache.delete(key);

  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.warn('Cache clear warning:', error);
  }
}

export function clearCacheByPrefix(prefix) {
  [...memoryCache.keys()].forEach((key) => {
    if (key.startsWith(prefix)) memoryCache.delete(key);
  });

  try {
    const removeKeys = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(prefix)) removeKeys.push(key);
    }
    removeKeys.forEach((key) => localStorage.removeItem(key));
  } catch (error) {
    console.warn('Cache prefix clear warning:', error);
  }
}

/* Compatibility aliases */
export const getCachedValue = getCache;
export const setCachedValue = setCache;
export const clearCachedValue = clearCache;
